import { useState } from "react";

export interface FilterGroup {
  key: string;
  label: string;
  options: string[];
  value: string;
}

interface FilterBarProps {
  groups: FilterGroup[];
  onChange: (key: string, value: string) => void;
  onReset: () => void;
}

export default function FilterBar({ groups, onChange, onReset }: FilterBarProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-8 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-3 flex items-center justify-between gap-3 md:hidden">
        <span className="flex items-center gap-1.5 text-sm font-medium text-foreground-700">
          <i className="ri-filter-3-line" aria-hidden="true"></i>
          筛选条件
        </span>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex items-center gap-1 rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-700 whitespace-nowrap"
        >
          {open ? "收起" : "展开"}
          <i className={open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} aria-hidden="true"></i>
        </button>
      </div>

      <div className={`${open ? "flex" : "hidden"} flex-col gap-3 md:flex md:gap-4`}>
        {groups.map((group) => (
          <div key={group.key} className="flex flex-col gap-2 md:flex-row md:items-center">
            <span className="w-16 shrink-0 text-sm font-medium text-foreground-500">{group.label}</span>
            <div className="flex flex-wrap gap-2">
              {group.options.map((option) => (
                <button
                  key={option}
                  type="button"
                  onClick={() => onChange(group.key, option)}
                  className={`rounded-full px-3 py-1 text-sm transition-colors whitespace-nowrap ${
                    group.value === option
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
        ))}
        <div className="border-t border-background-200 pt-3">
          <button
            type="button"
            onClick={onReset}
            className="flex items-center gap-1.5 rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-600 whitespace-nowrap"
          >
            <i className="ri-refresh-line" aria-hidden="true"></i>
            重置筛选
          </button>
        </div>
      </div>
    </div>
  );
}